import script from "./ThumbnailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThumbnailPage.vue?vue&type=script&setup=true&lang=ts"

import "./ThumbnailPage.vue?vue&type=style&index=0&id=664aaa39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664aaa39"]])

export default __exports__